import styled from "styled-components";

export const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2em 4em;
  padding: 1em;
  flex-direction: column;

  > h1 {
    margin-bottom: 1em;
  }

  > hr {
    border: none;
    height: 1px;
    margin: 1rem 0;
    width: 100%;
  }

  .button {
    margin-top: 2em;
  }
`;
